import {
  React,
  useRef,
  useEffect,
  useCallback,
  Button,
  OtpInput,
  toast,
  useState,
  LoadingSpinner,
  Box,
  Dialog,
  useGetAllScreensMutation,
  Screens,
  GetCookie,
  BASEURL,
} from "../../../Libraries/Screens/index";
import { API_BASEURL } from "../../../Utils/Constants/constants";
import "./style.scss";
import SnackbarContent from '@mui/material/SnackbarContent';
const AddNewScreen = () => {
const [getAllScreensfromdb, { isLoading }] = useGetAllScreensMutation();
const screenname = useRef();
const [isdisable, setisdisable] = useState(false);

  const [data, setdata] = useState({
    DeviceDetailsDialog: false,
    otpsentforscreen: false,
    opendialog: false,
    deviceinformation: null,
    ScreenName: null,
    Screenid: null,
    modeldetail: [],
    otp: "",
    AllScreens: null,
  });

  //get device details after activation code
  const GetDeviceDetails = async () => {
    const getdevicedetails = new FormData();
    getdevicedetails.append(
      "txt_customer_id",
      localStorage.getItem("txt_customer_id")
    );
    getdevicedetails.append("txt_screen_name", screenname.current?.value);
    getdevicedetails.append("ser_screen_id", data.Screenid);
    getdevicedetails.append("ser_code_id", localStorage.getItem("ser_code_id"));
    getdevicedetails.append("security_token", await GetCookie("es_token"));
    getdevicedetails.append("txt_activation_code", data.otp);


    const getdevicedetailsoptions = {
      method: "POST",
      body: getdevicedetails,
      cache: "no-cache",
      referrerPolicy: "no-referrer",
    };

    fetch(API_BASEURL + "connectScreen.php", getdevicedetailsoptions)
      .then(function (response) {
        if (response.status !== 200) {
          toast(response.Error);
          console.log("Error", response);
        } else {
          response.json().then(function (data) {
            if (
              data.connection === "true" &&
              data.status === "true" &&
              (data.message === "Screen mapped successfully" || data.message === "Screen mapped successfully. Kindly restart screen from your Smart TV remote")
            ) {
              toast.success(data.message);
              setTimeout(() => {
                getAllScreens();
              }, 1000);
              hideDialog();
            }
            else if (data.connection === "true" &&
            data.status === "true" &&
            (data.message === "Screen mapped successfully. Kindly restart screen from your Smart TV remote")){
              toast.error(data.message);
              getAllScreens();
              hideDialog();
            }
            else {
              toast.error(data.message);
              hideDialog();
            }
          });
        }
      })
      .catch((error) => {
        toast(error.message);
        console.error(error);
      });
  };

  //verify otp api call
  const openDetailsDialog = async () => {
    const verifyscreenotp = new FormData();
    verifyscreenotp.append("txt_activation_code", data.otp);
    verifyscreenotp.append(
      "txt_customer_id",
      localStorage.getItem("txt_customer_id")
    );
    verifyscreenotp.append("security_token", await GetCookie("es_token"));

    const verifyscreenotpoptions = {
      method: "POST",
      body: verifyscreenotp,
      cache: "no-cache",
      referrerPolicy: "no-referrer",
    };

    if (data.otp.length < 6) {
      toast.error("Please add complete device code");
    } else {
      fetch(
        BASEURL + "screen/getActivationCodeDetails.php",
        verifyscreenotpoptions
      )
        .then(function (response) {
          if (response.status !== 200) {
            toast(response.Error);
            console.log("Error", response);
          } else {
            response.json().then(function (data) {
              if (
                data.connection === "true" &&
                data.status === "true" &&
                data.message === "Information available"
              ) {
                localStorage.setItem("ser_code_id", data.data[0].ser_code_id);
                setdata((previousvalue) => ({
                  ...previousvalue,
                  // otp: "",
                  otpsentforscreen: false,
                  DeviceDetailsDialog: true,
                  opendialog: true,
                  deviceinformation: data.data[0],
                  modeldetail: data.data[0]?.txt_android_model.split(","),
                }));
              } else if (
                data.connection === "true" &&
                data.status === "false" &&
                data.message === "Today rate limit is exceeded"
              ) {
                setisdisable(true);
                toast.info(data.message);
              } else {
                toast.error(data.message);
              }
            });
          }
        })
        .catch((error) => {
          toast(error.message);
          console.error(error);
        });
    }
  };

  const getAllScreens = useCallback(async () => {
    const verifyscreenotp = new FormData();
    verifyscreenotp.append(
      "txt_customer_id",
      localStorage.getItem("txt_customer_id")
    );
    verifyscreenotp.append("security_token", await GetCookie("es_token"));

    try {
      const returned = await getAllScreensfromdb(verifyscreenotp).unwrap();
      if (
        returned.status === "true" &&
        returned.connection === "true" &&
        returned.message === "Screens available"
      ) {
        setdata((previousvalue) => ({
          ...previousvalue,
          // AllScreens: returned.data,
          AllScreens: [...returned.data],
        }));
      } else {
        toast.error(returned.message);
      }
    } catch (error) {
      toast.error(error.status);
      console.log(error);
    }
  }, [getAllScreensfromdb]);

  useEffect(() => {
    getAllScreens();
  }, [getAllScreens]);

  const otpverification = (
    <React.Fragment>
      <Button
        variant="contained"
        onClick={openDetailsDialog}
        disabled={isdisable}
        className="capitalized fs-14 fw-bold"
      >
        verify
      </Button>
    </React.Fragment>
  );

  const devicedetaildialog = (
    <React.Fragment>
      <Button variant="contained" onClick={GetDeviceDetails} className="capitalized fs-14 fw-bold">
        Submit
      </Button>
    </React.Fragment>
  );

  //onDialoghide
  const hideDialog = () => {
    setdata((previousvalue) => ({
      ...previousvalue,
      otp: "",
      otpsentforscreen: true,
      DeviceDetailsDialog: false,
      opendialog: false,
    }));
  };

  //onDialogopen
  const handleopendialog = (screeninfo, screenid) => {
    setdata((previousvalue) => ({
      ...previousvalue,
      otpsentforscreen: true,
      DeviceDetailsDialog: false,
      opendialog: true,
      ScreenName: screeninfo,
      Screenid: screenid,
    }));
  };

  //onDialogopen
  const handleChangeotp = useCallback((e) => {
    setdata((previousvalue) => ({
      ...previousvalue,
      otp: e,
    }));
  }, []);

  return (
    <>
      {isLoading ? <LoadingSpinner /> : null}
      <Box sx={{ flexGrow: 1, mr: 0, mt: 1 }}>
        <Dialog
          visible={data?.opendialog}
          style={{ width: "400px", borderRadius: "20px" }}
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          header={data?.otpsentforscreen ? "Activation Code" : "Device Detail"}
          modal
          className="p-fluid"
          footer={data?.otpsentforscreen ? otpverification : devicedetaildialog}
          onHide={hideDialog}
        >
          {data?.otpsentforscreen && !data?.DeviceDetailsDialog ? (
            <div className="otp__wrrapper">
              <OtpInput
                value={data.otp}
                onChange={handleChangeotp}
                numInputs={6}
                separator={<span style={{ width: "8px" }}></span>}
                renderInput={(props) => <input {...props} />}
                shouldAutoFocus
                inputStyle={{
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  width: "50px",
                  height: "50px",
                  fontSize: "12px",
                  color: "#000",
                  fontWeight: "400",
                  caretColor: "blue",
                  backgroundColor: "darkgray",
                }}
                focusStyle={{
                  border: "1px solid #CFD3DB",
                  outline: "none",
                }}
              />
            </div>
          ) : data.DeviceDetailsDialog && !data.otpsentforscreen ? (
            <>
              <div className="row">
                <div className="col">Model:</div>
                <div className="col">{data.modeldetail[0]}</div>
              </div>
              <div className="row">
                <div className="col">Brand:</div>
                <div className="col">{data.modeldetail[1]}</div>
              </div>
              <div className="row">
                <div className="col">Device:</div>
                <div className="col">{data.modeldetail[2]}</div>
              </div>
              <div className="row">
                <div className="col">Version:</div>
                <div className="col">
                  {data.deviceinformation?.txt_android_version}
                </div>
              </div>

              <div className="row">
                <input
                  className="form-control border-0 shadow-sm text-center"
                  placeholder="Screen Name"
                  ref={screenname}
                  defaultValue={data.ScreenName ? data.ScreenName : ""}
                />
                
              </div>
            </>
          ) : null}
        </Dialog>
        {/* All Screen */}
        <Screens
          key={data.AllScreens?.length}
          handleopendialog={handleopendialog}
          AllScreens={data.AllScreens ? data.AllScreens : []}
          getAllScreens={getAllScreens}
        />
      </Box>
    </>
  );
};

export default AddNewScreen;